import {format} from 'date-fns';

const convertDate = (created: string) => {
    return format(new Date(created.replace(/-/g, '/')), "MMMM dd, yyyy")
}

export {convertDate};
